import {getLabelName} from "@/util/label"
export default {
  path: '/user',
  title: ' 用户管理',
  icon: 'user',
  hideSub: true,
  children: (pre => [
    // {
    //   title: '用户列表',
    //   icon: 'cubes',
    //   path: `${pre}user`
    // },
    {
      title: '角色列表',
      icon: 'user',
      path: `${pre}role`
    },
    {
      title: getLabelName('DEPT')+'管理',
      icon: 'cube',
      path: `${pre}dept`
    },
    {
      title: '记者账号管理',
      icon: 'user',
      path: `${pre}reporter`
    }
  ])('/user/')
}
